import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AdminPslfForms extends Controller {
  @tracked formType = '';
  @tracked group = '';
  @tracked limit = 25;
  @tracked page = 1;
  @tracked search = '';
  @tracked order = 'created_at';
  @tracked status = 'borrower_signed';

  queryParams = ['search', 'group', 'status', 'formType', 'page', 'limit', 'order'];

  resetQueryParams = () => {
    this.formType = '';
    this.group = '';
    this.limit = 25;
    this.page = 1;
    this.search = '';
    this.order = 'created_at';
    this.status = 'borrower_signed';
  };
}
